$(document).ready(function() {

  function getCart() {
    return $.getJSON('/cart.js');
  }

  function hasSubscription(cart) {
    return cart.items.some(item => item.selling_plan_allocation);
  }

  function hasRegular(cart) {
    return cart.items.some(item => !item.selling_plan_allocation);
  }

  function showToast(message) { 
let toast = $(`
  <div class="custom-toast" style="
    position: fixed;
    top: 58px;
    right: 70px;
    background: #523500;
    color: #fff;
    padding: 8px 50px;
    border-radius:0; 
    box-shadow:0 6px 16px rgba(0,0,0,0.35); 
    z-index:9999; 
    font-size:0.9rem; 
    display:none; 
    word-wrap:break-word; 
    display:flex; 
    align-items:center; 
    gap:10px;
  ">
    <span style="font-weight:bold;">⚠️</span>
    <span class="toast-text">Ihre Nachricht hier</span>
  </div>
`);

    $('body').append(toast);
    toast.text(message).fadeIn();
    setTimeout(() => toast.fadeOut(() => toast.remove()), 2500);
  }

  $(document).on('click', 'form[action="/cart/add"] [type="submit"]', function(e) {
    const form = $(this).closest('form');
    const sellingPlan = form.find('[name="selling_plan"]').val();
    const isAddingSubscription = sellingPlan && sellingPlan !== "";
    const isAddingRegular = !isAddingSubscription;

    e.preventDefault();

    getCart().then(cart => {
      if (hasSubscription(cart) && isAddingRegular) {
        showToast("Abonnements können nicht mit anderen Produkten gemeinsam gekauft werden."); // abo product
        return;
      }

      if (hasRegular(cart) && isAddingSubscription) {
        showToast("Abonnements können nicht mit anderen Produkten gemeinsam gekauft werden."); //  normal  product
        return;
      }

      form.trigger('submit');
    });
  });

});
